import React from "react";

import SpLink from "../../../../shared/SpLink";

import styles from "./MenuItemLink.module.scss";

type MenuItemLinkType = {
  children?: React.ReactNode;
  className?: string;
  isPricing?: boolean;
  isSignIn?: boolean;
  menuItemLabel: string;
  path: string;
  target?: "_blank";
  [key: string]: any;
};

const MenuItemLink: React.FC<MenuItemLinkType> = ({
  className,
  isPricing,
  isSignIn,
  menuItemLabel,
  path,
  target,
  ...rest
}) => {
  const pricingMenuItem = isPricing && styles.isPricing;
  const signInMenuItem = isSignIn && styles.isSignIn;
  const menuItemStyles = `${styles.menuItemLink} ${pricingMenuItem} ${signInMenuItem}`;

  return (
    <li
      data-testid="menu-item-link"
      role="menuitem"
      className={`${menuItemStyles} ${className}`}
      {...rest}
    >
      <SpLink
        path={path || ""}
        target={target || ""}
        className={styles.navLinkLabel}
        data-testid="menu-item-sp-link"
      >
        <span className={styles.label}>{menuItemLabel}</span>
      </SpLink>
    </li>
  );
};

export default MenuItemLink;
